import { createSelector } from '@reduxjs/toolkit'
import { tenantUsersApi } from 'services/tenantUsers.service'

const selectMyTenantUserQuery = tenantUsersApi.endpoints.getMyself.select()

export const selectMyUser = createSelector(selectMyTenantUserQuery, (state) => state.data)
